import React from "react";
import achivements from "../utils/achievement";
import AchievementItem from "./AchievementItem";

function AchievementSection() {
  return (
    <div className="container">
      <div className="tokyo_tm_news">
        <div className="tokyo_tm_title">
          <div className="title_flex">
            <div className="left">
              <h4>Achievements</h4>
            </div>
          </div>
        </div>
        <ul>
          {achivements.map((a) => (
            <AchievementItem
              key={a.id}
              title={a.title}
              by={a.by}
              date={a.date}
              imageUrl={a.imageUrl}
              description={a.description}
              additionalImage={a.additionalImage}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AchievementSection;
